module.exports = __webpack_public_path__ + "svg/logo-guarantee-blue.2a4c726.svg";